import { Preferences } from '@capacitor/preferences';

export const setAppStorage = async (key: string, value: any): Promise<void> => {
  let stringified;

  if (typeof value !== 'string') {
    stringified = JSON.stringify(value);
  } else {
    stringified = value;
  }

  await Preferences.set({
    key,
    value: stringified,
  });
};

export const getAppStorage = async (key: string): Promise<any> => {
  const { value } = await Preferences.get({ key });
  try {
    if (typeof value === 'string' && value.trim() !== '') {
      return JSON.parse(value);
    }

    return value; // fallback to return the raw value

  } catch (e) {
    console.warn(`Failed to parse value from key "${key}":`, value);
    return value; // fallback
  }
};

export const deleteAppStorage = async (key: string): Promise<void> => {
  await Preferences.remove({ key });
};
